import { OwcCheckbox, OwcTooltip, OwcTypography } from "@one/react";
import { react18WorkaroundProps } from "../../../../utils/constants/constants";
import { useCallback, useRef } from "react";
import { DEBOUNCE_MS, STYLES } from "../constants";
import { ResourceItemProps } from "../types";

const ResourceItem: React.FC<ResourceItemProps> = ({ resource, isSelected, onSelectionChange }) => {
  const isProcessingRef = useRef(false);

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();

      if (isProcessingRef.current) { return; }
      isProcessingRef.current = true;

      onSelectionChange(resource.id as string, !isSelected);

      setTimeout(() => {
        isProcessingRef.current = false;
      }, DEBOUNCE_MS);
    },
    [resource.id, isSelected, onSelectionChange],
  );

  const resourceId = `resource-${resource.id}`;

  return (
    <div className="md-resource-header-template-cont md-row-leaf">
      <div className="md-resource-header-template-name">
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <OwcCheckbox
            checked={isSelected}
            onClick={handleClick}
            {...react18WorkaroundProps}
          />
          <OwcTypography
            variant="body2"
            style={STYLES.resourceName}
            id={resourceId}
            {...react18WorkaroundProps}
          >
            {resource.name}
          </OwcTypography>
          <OwcTooltip
            anchor={resourceId}
            {...react18WorkaroundProps}
          >
            {resource.name}
          </OwcTooltip>
        </div>
      </div>
    </div>
  );
};

export default ResourceItem;
